import { render } from "./RecentlySinglePodcast.vue?vue&type=template&id=85c46f32&scoped=true"
import script from "./RecentlySinglePodcast.vue?vue&type=script&lang=js"
export * from "./RecentlySinglePodcast.vue?vue&type=script&lang=js"

import "./RecentlySinglePodcast.vue?vue&type=style&index=0&id=85c46f32&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85c46f32"]])

export default __exports__